import styled from 'styled-components'
import { Link } from 'react-router-dom'
import config from '../../config/configurator'
import Select from 'react-select'
import datePickerIcon from '../../images/datePickerIcon.svg'

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 1215px;
  margin: 1rem 0 1rem 0;
`

export const GridHeaderContainer = styled.div`
  position: absolute;
  z-index: 2;
  top: 32.5px;
`

export const DashboardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

`

export const FilterContainer = styled.div`
  align-items: center;
`

export const ButtonContainer = styled.div`
  position: absolute;
  right: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 31px;
  width: 80px;
`

export const ResetButtonContainer = styled.div`
  display: flex;
  height: 30.72px;
  width: 30.72px;
  border: 1px solid ligtgray;
  border-radius: 5px;
  background-color: white;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  &:hover {
    background-color: #AAE5F3;
  }
`

export const ValidateButtonContainer = styled.div`
  display: flex;
  height: 30.72px;
  width: 30.72px;
  border: 1px solid ligtgray;
  border-radius: 5px;
  background-color: white;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  &:hover {
    background-color: #AAE5F3;
  }
`

export const FilterSubContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 90%;
  height: 3rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: #eff0f6;
  border-radius: 5px;
`

export const InputContainer = styled.div`
  height: 60%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 5px;
  background-color: white;
  margin-left: 5px;
  position: relative;
`

export const Input = styled.input`
  height: 100%;
  display: flex;
  font-family:Poppins;
  color: black;
  width: 100%;
  padding-left: 26px;
  font-size: 13px;
  border: 1px solid lightgray;
  box-sizing: content-box;
  border-radius: 5px;
  outline-color: #2684FF;
  cursor: pointer;
  &:focus {
    box-sizing: content-box;
    border-radius: 5px;
  }
  ::placeholder,
  ::-webkit-input-placeholder {
    color: black;
  }
  :-ms-input-placeholder {
     color: black;
  
`

export const IconImg = styled.img`
  height: 0.7vw;
  padding-left: 5px;
  position: absolute;
  left: 5px;
`

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Poppins;
  margin-right: 12px;
`

export const PaginationButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  border: 1px solid ${props => props.disabled ? '#e0e0e0' : '#c0b8cc'};
  background: ${props => props.disabled ? '#f5f5f5' : '#fff'};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  transition: background 0.15s, border-color 0.15s;
  &:hover:not(:disabled) {
    background: #ede8f5;
    border-color: #024179;
  }
`

export const PaginationInfo = styled.span`
  font-family: Poppins;
  font-size: 0.82rem;
  color: #3d3d3d;
  min-width: 70px;
  text-align: center;
  white-space: nowrap;
  & b {
    color: #024179;
  }
`

export const LayoutContainer = styled.div`
  height:100%;
  width:70vw;
  margin-left:3rem;
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items: center;
  position: relative;
`
export const ActionContainer = styled.div`
  display: flex;
  align-items: center;  
  justify-content: center;
  height: 3rem;
`
export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  height: 3rem;
  width: 5rem;
  justify-content: space-around;
`

export const Container = styled.div`
  margin-top: 2%;
`
export const Loader = styled.div`
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #024179;
  width: 3rem;
  height: 3rem;
  margin-top:1rem;
  font-family:Poppins;
  animation: spin 1s linear infinite;

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`

export const Action = styled.div`
  display: flex;
  top:20%;
  flex-direction: center;
  justify-content: center;
  align-items: center;
  height: 1.6vw;
  width: 1.6vw;
  border: 1px solid black;
  border-radius: 0.225rem;
  cursor: pointer;
  &:hover {
    background-color: #AAE5F3;
  }
  border: ${config.colors.ActionMail};
  background-color: white;
`

export const InactiveAction = styled.div`
  display: flex;
  top:20%;
  flex-direction: center;
  justify-content: center;
  align-items: center;
  height: 1.6vw;
  width: 1.6vw;
  border: 1px solid black;
  border-radius: 0.225rem;
  border: ${config.colors.ActionMail};
  background-color: white;
`

export const ActionEdit = styled(Action)``

export const ActionDelete = styled(Action)``

export const ActionTransfer = styled.button`
  margin-left: 0.2rem;
  margin-right: 0.2rem;
`

export const ActionArchive = styled(Action)``

export const EditIcon = styled.img`
  height: 0.8vw;
  object-fit: content;
`

export const ArrowPageRight = styled.img`
  height: 0.8vw;
  object-fit: content;
  transform: rotate(-90deg);
`

export const ArrowPageLeft = styled.img`
  height: 0.8vw;
  object-fit: content;
  transform: rotate(90deg);
`

export const DeleteIcon = styled.img`
  height: 0.7vw;
`
export const ArchiveIcon = styled.img`
  height: 0.7vw;
`

export const Bg = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
  overflow-x:hidden;
`

export const Progression = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: space-around;
  height: 55px;
`

export const ProgressionBar = styled.div`
  margin-left: -0.7rem;
  width: 80%;
  height: 1.3rem;
  background: white; 
  border-radius: 0.3rem;
  margin-top: -0.4rem;
`

export const ProgressionBarIn = styled.div`
  height: 100%;
  border-radius: 0.3rem;
  background: linear-gradient(90deg, #1AA0FF 0%, #166DD8 95.42%);
`

export const ProgressionText = styled.div`
  width: 25%;
  margin-left: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 10px;
`

export const HoverPanel = styled.div`
  position: absolute;
  color: white;
   height: 1.5rem;
   padding-left: 0.3rem;
   padding-right: 0.3rem;
   padding-top: 0.3rem;
   font-size: 0.6rem;
   font-family: Poppins;
   font-weight: 400;
   background-color: #4F4F4F;
   border-radius: 0.3rem;
   z-index: 10;
`

export const TopBarContainer = styled.div`
  height: 3.5rem;
  display: flex;
  align-items: center;
  position: relative;
`

export const TopBar = styled.div`
  font-family: Poppins;
  font-weight: 500;
  font-size: 1.1rem;
`

export const EvalBar = styled.div`
  border-bottom: solid #53AD49 0.3rem;
  width: 214px;
  font-family: Poppins;
  font-weight: 500;
  font-size: 1.1rem;
`

export const SimulBar = styled.div`
  border-bottom: solid #297FCC 0.3rem;
`

export const SelectorContainer = styled.div`
  height: 2.7rem;
  display: flex;
  align-items: center;
`

export const FirstContainer = styled.div`
  width: 100%;
  min-height: 18rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.25rem 0.75rem 0.5rem;
`

export const EmptyStateCard = styled.div`
  width: min(34rem, 100%);
  background: linear-gradient(180deg, #FFFFFF 0%, #F8FAFF 100%);
  border: 1px solid #E3E8F3;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(15, 50, 105, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.45rem;
  padding: 1.4rem 1.1rem 1.25rem;
`

export const EmptyStateIcon = styled.div`
  width: 2.1rem;
  height: 2.1rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #00B6EC 0%, #3A77E8 100%);
  color: white;
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 700;
`

export const ContainerFirstStudent = styled.div`
  width: 377px;
  height: 322px;
  display: flex;
  flex-direction: column;
  border: 1px solid #9C9C9D;
  box-sizing: border-box;
  box-shadow: 4px 4px 9px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
`

export const AvatarContainer = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
`

export const TextFirstCSV = styled.p`
  text-align: center;
  margin: 0;
  width: 100%;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.4;
  color: #1F2937;
`

export const EmptyStateSubText = styled.p`
  margin: 0;
  max-width: 28rem;
  text-align: center;
  font-family: Poppins;
  font-size: 0.84rem;
  line-height: 1.45;
  color: #667085;
`

export const ButtonImport = styled.div`
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: center;
  margin-top: 2.25rem;
`

export const ButtonTransfer = styled(Link)`
&:hover {
  background-color: #AAE5F3;
}
`

export const ImportImg = styled.img`
  width:1rem;
  height:1rem;
  display: flex;
  position: absolute;
  left: 1rem;
`

export const ImportText = styled.div`
  font-size: 16px;
  color: black;
  width: 100%;
  position: absolute;
  left: 2rem;
  margin-left: 8px;
`

export const ButtonCreate = styled(Link)`
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  border: 1px solid #979797;
  background-color:#ffffff;
  color:black;
  font-family:Poppins;
  font-style:normal;
  font-size:1rem;
  margin-bottom:1rem;
  line-height:3rem;
  box-shadow: 0px 2px 7px rgba(0,0,0,0.14);
  position: absolute;
`

export const TransferButton = styled(Link)`
  text-decoration:none;
  font-size: 1rem;
`

export const Box = styled.div`
  display: flex;
  align-items: center;
  height: 31px;
`

export const IconFilter = styled.img`
  margin-left: 1.125rem;
  margin-right: 0.75rem;
`
export const FilterText = styled.div`
  color: black;
  font-family: Poppins;
  font-size: 12px;
  line-height: 23.27px;
  display: flex;
  padding-right: 1.25rem;
`

export const LicenceSelector = styled(Select)`
.react-select__control {
  width: 7rem;
  color:black;
  font-family:Poppins;
  font-size:13px;
  height: 2rem;
  min-height: 2rem;
  cursor: pointer
}
.react-select__option {
  font-family: Poppins;
  font-size: 13px;
  cursor:  pointer;
}
.react-select__indicator-separator {
  display: none;
}
.react-select__dropdown-indicator {
  padding: 0px 5px 0px 0px;
  color: black;
  width: 20px;
}
`

export const StatusSelector = styled(Select)`
.react-select__control {
  width: 11.7rem;
  color:black;
  font-family:Poppins;
  font-size:13px;
  height: 2rem;
  min-height: 2rem;
  cursor: pointer
}
.react-select__option {
  font-family: Poppins;
  font-size: 13px;
  cursor:  pointer;
}
.react-select__indicator-separator {
  display: none;
}
.react-select__dropdown-indicator {
  padding: 0px 5px 0px 0px;
  color: black;
  width: 20px;
}
`

export const AgencySelector = styled(Select)`
.react-select__control {
  width: 12rem;
  color:black;
  font-family:Poppins;
  font-size:13px;
  height: 2rem;
  min-height: 2rem;
  cursor: pointer
}
.react-select__option {
  font-family: Poppins;
  font-size: 13px;
  cursor:  pointer;
}
.react-select__indicator-separator {
  display: none;
}
.react-select__dropdown-indicator {
  padding: 0px 5px 0px 0px;
  color: black;
  width: 20px;
}
`

export const DateFilter = styled.input`
  z-index: 1;
  width: 104px;
  height: 1.9rem;
  border: 1px solid hsl(0, 0%, 80%);
  border-radius: 5px;
  margin-left: -303px;
  cursor: pointer;
  font-family: Poppins;
  font-weight: 300;
  font-size: 11px;
  padding-left: 8px;
  &:focus {
    outline-color: #2684FF;
  }
  ::-webkit-calendar-picker-indicator {
    background: url(${datePickerIcon}) no-repeat;
    width: 16px;
    height: 16px;
    cursor: pointer;
    margin: 4px 2px 0px 0px;
}
`

/* ── New date filter (no negative margin hack) ─────────────────── */
export const InlineDateFilter = styled.input`
  height: 2rem;
  width: 8rem;
  border: 1px solid #D8D8D8;
  border-radius: 6px;
  cursor: pointer;
  font-family: Poppins;
  font-size: 0.78rem;
  padding: 0 0.4rem 0 0.5rem;
  background: white;
  color: #374151;
  outline: none;
  flex-shrink: 0;
  &:focus { border-color: #3494FA; box-shadow: 0 0 0 2px rgba(52,148,250,0.15); }
  ::-webkit-calendar-picker-indicator {
    background: url(${datePickerIcon}) no-repeat;
    width: 14px;
    height: 14px;
    cursor: pointer;
    opacity: 0.5;
  }
`

/* ═══════════════════════════════════════════════════════════════
   PAGE HEADER
═══════════════════════════════════════════════════════════════ */

export const SPHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 2rem 1.5rem;
`

export const SPHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
`

export const SPIconBox = styled.div`
  width: 4.0625rem;
  height: 4.0625rem;
  border-radius: 0.9375rem;
  background: linear-gradient(223deg, rgba(0,200,248,1) 16%, rgba(104,94,252,1) 78%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 4px 16px rgba(100,98,252,0.25);
`

export const SPIconImg = styled.img`
  width: 2.125rem;
  height: 2.125rem;
  object-fit: contain;
  filter: brightness(0) invert(1);
`

export const SPTitle = styled.h1`
  font-family: Poppins;
  font-size: 2rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
  line-height: 1.15;
`

export const SPSubtitle = styled.p`
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 400;
  color: #000000;
  opacity: 0.5;
  margin: 0;
`

export const SPCreateBtn = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 2.75rem;
  padding: 0 1.375rem;
  background: linear-gradient(135deg, #00C4F3 0%, #6462FC 100%);
  border-radius: 10px;
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: white;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(100,98,252,0.3);
  transition: opacity 0.15s, box-shadow 0.15s, transform 0.15s;
  & img {
    width: 1.05rem;
    height: 1.05rem;
    object-fit: contain;
    filter: brightness(0) invert(1);
  }
  &:hover {
    opacity: 0.92;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(100,98,252,0.38);
  }
  &:active { transform: translateY(0); }
`

export const SPDivider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, #EFF0F6 0%, #E4E5F0 50%, #EFF0F6 100%);
  margin: 0 2rem;
  margin-bottom: 1.25rem;
`

/* ═══════════════════════════════════════════════════════════════
   MODERN TABLE DESIGN
═══════════════════════════════════════════════════════════════ */

export const TablePageLayout = styled.div`
  padding: 0 2rem 3rem;
`

export const FilterRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem;
  background: #EFF0F6;
  border-radius: 10px;
  padding: 0.625rem 0.75rem;
  margin-bottom: 0.875rem;
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const FilterFieldLabel = styled.div`
  font-family: Poppins;
  font-size: 0.72rem;
  font-weight: 600;
  color: #5a6170;
`

export const FilterSearchBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  & img {
    position: absolute;
    left: 0.55rem;
    height: 0.72rem;
    opacity: 0.4;
    z-index: 1;
    pointer-events: none;
  }
  & input {
    height: 2rem;
    width: 11.5rem;
    border: 1px solid #D8D8D8;
    border-radius: 6px;
    background: white;
    font-family: Poppins;
    font-size: 0.8rem;
    color: #1A1A2E;
    padding: 0 0.75rem 0 2rem;
    outline: none;
    &::placeholder { color: #B0B8C5; }
    &:focus { border-color: #3494FA; box-shadow: 0 0 0 2px rgba(52,148,250,0.12); }
  }
`

export const FilterIconBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  width: 2rem;
  border-radius: 6px;
  border: 1px solid #D8D8D8;
  background: white;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.12s;
  padding: 0;
  & img { height: 0.72rem; opacity: 0.5; }
  &:hover { background: #EEF5FF; border-color: #3494FA; & img { opacity: 1; } }
`

export const PaginationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 0.75rem;
`

export const TableCard = styled.div`
  background: white;
  border-radius: 16px;
  border: 1px solid #E8EBF0;
  box-shadow: 0px 4px 32px rgba(43, 123, 199, 0.12);
  overflow: hidden;
`

export const TableScroll = styled.div`
  overflow-x: auto;
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 860px;
`

/* border-bottom et background doivent être sur th, pas thead — border-collapse: collapse ignore les borders sur thead */
export const STHead = styled.thead``

export const STH = styled.th`
  padding: 0 0.875rem;
  height: 2.875rem;
  text-align: left;
  vertical-align: middle;
  font-family: Poppins;
  font-size: 0.685rem;
  font-weight: 700;
  color: #5A6170;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  white-space: nowrap;
  background: #EEF0F6;
  border-bottom: 2px solid #D8DCE8;
  border-right: 1px solid #D8DCE8;
  &:last-child { border-right: none; }
`

export const STBody = styled.tbody``

export const STR = styled.tr`
  border-bottom: 1px solid #EAEDF3;
  transition: background 0.12s;
  ${p => p.$inactive && `
    > td:not([data-keep-color='true']) { opacity: 0.45; }
  `}
  &:hover { background: #F4F7FF; }
  &:last-child { border-bottom: none; }
`

export const STD = styled.td`
  padding: 0 0.875rem;
  height: 4rem;
  vertical-align: middle;
  font-family: Poppins;
  font-size: 0.875rem;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-right: 1px solid #EAEDF3;
  &:last-child { border-right: none; }
`

export const PlayerCellWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`

export const InitialBubble = styled.div`
  flex-shrink: 0;
  width: 2.125rem;
  height: 2.125rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #00C4F3 0%, #6462FC 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Poppins;
  font-size: 0.72rem;
  font-weight: 700;
  color: white;
  letter-spacing: 0.01em;
`

export const PlayerRowLink = styled(Link)`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  &:hover { color: #3494FA; }
`

export const PlayerRowSpan = styled.span`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: #9CA3AF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`

export const PermisTag = styled.span`
  display: inline-flex;
  align-items: center;
  height: 1.5rem;
  padding: 0 0.6rem;
  background: #EEF2FF;
  border: 1px solid #C7D2FE;
  border-radius: 100px;
  font-family: Poppins;
  font-size: 0.7rem;
  font-weight: 700;
  color: #4F46E5;
  letter-spacing: 0.03em;
  white-space: nowrap;
`

export const EvalScoreLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2rem;
  height: 1.625rem;
  padding: 0 0.5rem;
  background: #EFF6FF;
  border: 1px solid #BFDBFE;
  border-radius: 6px;
  font-family: Poppins;
  font-size: 0.78rem;
  font-weight: 700;
  color: #2563EB;
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.08);
  transition: background 0.12s, border-color 0.12s, color 0.12s, box-shadow 0.12s;

  &:hover {
    background: #3494FA;
    border-color: #3494FA;
    color: #FFFFFF;
    box-shadow: 0 2px 5px rgba(52, 148, 250, 0.25);
  }
`

export const StatusTag2 = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  height: 1.625rem;
  padding: 0 0.75rem;
  border-radius: 100px;
  font-family: Poppins;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  background: ${p => p.$active ? '#DCFCE7' : '#F3F4F6'};
  color: ${p => p.$active ? '#16A34A' : '#9CA3AF'};
  &::before {
    content: '';
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
    flex-shrink: 0;
  }
`

export const TransferChip = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.75rem;
  padding: 0 0.75rem;
  background: #EEF2FF;
  border: 1px solid #C7D2FE;
  border-radius: 6px;
  font-family: Poppins;
  font-size: 0.72rem;
  font-weight: 600;
  color: #4F46E5;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(79, 70, 229, 0.08);
  transition: background 0.12s, border-color 0.12s, color 0.12s, box-shadow 0.12s;
  &:hover {
    background: #6462FC;
    border-color: #6462FC;
    color: #FFFFFF;
    box-shadow: 0 2px 5px rgba(100, 98, 252, 0.25);
  }
`

export const FormationList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
`

export const FormationChip = styled.span`
  display: inline-flex;
  align-items: center;
  height: 1.35rem;
  padding: 0 0.5rem;
  background: rgba(100, 98, 252, 0.07);
  border: 1px solid rgba(100, 98, 252, 0.22);
  border-radius: 100px;
  font-family: Poppins;
  font-size: 0.66rem;
  font-weight: 600;
  color: #6462FC;
  white-space: nowrap;
  max-width: 9rem;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const MoreChip = styled.span`
  display: inline-flex;
  align-items: center;
  height: 1.35rem;
  padding: 0 0.5rem;
  background: #F3F4F6;
  border-radius: 100px;
  font-family: Poppins;
  font-size: 0.66rem;
  font-weight: 600;
  color: #6B7280;
  white-space: nowrap;
`

export const NoneText = styled.span`
  font-family: Poppins;
  font-size: 0.85rem;
  color: #D1D5DB;
`

export const TableActions2 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
`

export const TActionBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 7px;
  border: 1px solid ${p => p.$danger ? 'rgba(239,68,68,0.22)' : '#E5E7EB'};
  background: ${p => p.$danger ? '#FEF2F2' : 'white'};
  cursor: pointer;
  transition: all 0.12s;
  padding: 0;
  text-decoration: none;
  flex-shrink: 0;
  & img {
    height: 0.85rem;
    width: 0.85rem;
    object-fit: contain;
    display: block;
  }
  &:hover {
    background: ${p => p.$danger ? '#FEE2E2' : '#EEF2FF'};
    border-color: ${p => p.$danger ? '#EF4444' : '#6462FC'};
  }
`

export const AgencyCellLink = styled(Link)`
  font-family: Poppins;
  font-size: 0.8rem;
  color: ${p => p.$inactive ? '#D1D5DB' : '#374151'};
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  pointer-events: ${p => p.$inactive ? 'none' : 'auto'};
  &:hover { color: #6462FC; }`